<template>
  <div>
    <email-manager :configurations="email_configurations" />
    <sms-manager ref="sms" />
  </div>
</template>

<script>
import EmailManager from "./EmailManagement/EmailManagement";
import SmsManager from "./SMSManagement/SmsManagement";
import { local_api, stringify } from "@/utils";
// import DatasourcePermissionModal from "./DatasourcePermissionModal";

export default {
  name: "MessagingManagement",
  props: {},
  components: {
    EmailManager,
    SmsManager,
  },
  data() {
    return {
      email_configurations: [],
      sms_configurations: [],
    };
  },
  methods: {},
  created() {},
  mounted() {
    let vm = this;
    local_api(vm, "post", "/settings/messaging/do-get-configuration")
      .then((messaging) => {
        vm.email_configurations = messaging.email || [];
        vm.sms_configurations = messaging.sms || [];

        vm.$refs.sms.setConfigurations(messaging.sms);
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {},
};
</script>
